module.exports = __webpack_public_path__ + "img/counter_l.879ad375.png";